import { useIsUngated } from 'automation-ui-core/hooks/authHooks';
import { SUPPORT_SELECTING_SENSITIVE_PROPERTIES } from 'automation-ui-enrollment/constants/Gates';
import { GET_FLAT_OBJECT_PROPERTIES } from 'automation-ui-enrollment/queries/ObjectPropertiesQueries';
import { useQuery } from 'data-fetching-client';
import { useState } from 'react';

// Delete after SUPPORT_SELECTING_SENSITIVE_PROPERTIES is ungated to all
export const useGetIsRestrictedSensitiveProperty = objectTypeId => {
  const [propertiesMap, setPropertiesMap] = useState();
  const isGatedToSupportSelectingSensitiveProperties = !useIsUngated(SUPPORT_SELECTING_SENSITIVE_PROPERTIES);
  const {
    data,
    loading,
    error
  } = useQuery(GET_FLAT_OBJECT_PROPERTIES, {
    variables: {
      objectTypeId
    },
    skip: !objectTypeId || !isGatedToSupportSelectingSensitiveProperties,
    onCompleted: response => {
      setPropertiesMap(response.flatProperties.reduce((acc, property) => {
        acc.set(property.property.name, property.property);
        return acc;
      }, new Map()));
    }
  });
  const getIsRestrictedSensitiveProperty = propertyName => {
    var _data$flatProperties, _propertiesMap$get;
    if (loading || !(data !== null && data !== void 0 && (_data$flatProperties = data.flatProperties) !== null && _data$flatProperties !== void 0 && _data$flatProperties.length) || !propertyName) {
      return false;
    }
    const dataSensitivity = propertiesMap === null || propertiesMap === void 0 || (_propertiesMap$get = propertiesMap.get(propertyName)) === null || _propertiesMap$get === void 0 ? void 0 : _propertiesMap$get.dataSensitivity;
    return dataSensitivity === 'high' || dataSensitivity === 'standard';
  };
  return {
    getIsRestrictedSensitiveProperty,
    loading,
    error
  };
};